import { GithubOutlined } from '@ant-design/icons';
import Styles from '../../Styles.module.scss';

export function PyLib() {
    return (
        <div className={Styles.PyLibSection}>
            <h2 className={Styles.SectionTitle}>Python Library</h2>
            <p className={Styles.SectionDescription}>
                Prefer Python? Use our Python library to control the ModelPark CLI and access published apps via API.
            </p>

            <div className={Styles.InstallCard}>
                <div className={Styles.InstallCardTitle}>Features</div>
                <ul style={{ margin: 0, paddingLeft: 20, lineHeight: 1.8, opacity: 0.7 }}>
                    <li>Run and serve apps in the background via the CLI</li>
                    <li>Manage running apps — list, logs, stop, kill</li>
                    <li>Make authenticated API calls to published apps</li>
                    <li>API key authentication for REST API apps</li>
                    <li>Programmatic access to all ModelPark CLI commands</li>
                </ul>

                <div style={{ marginTop: 24 }}>
                    <div className={Styles.StepLabel} style={{ marginBottom: 8 }}>
                        Installation
                    </div>
                    <div className={Styles.CodeBlock}>
                        <code>pip install modelpark</code>
                    </div>
                </div>

                <div style={{ marginTop: 24 }}>
                    <div className={Styles.StepLabel} style={{ marginBottom: 8 }}>
                        Quick Start — CLI Wrapper
                    </div>
                    <div className={Styles.CodeBlock}>
                        <code style={{ whiteSpace: 'pre' }}>{
`from modelpark import ModelPark

mp = ModelPark()
mp.login(token="your_token")
mp.serve(name="my-app", port=8000)
mp.ls()`
                        }</code>
                    </div>
                </div>

                <div style={{ marginTop: 16 }}>
                    <div className={Styles.StepLabel} style={{ marginBottom: 8 }}>
                        Quick Start — API Access
                    </div>
                    <div className={Styles.CodeBlock}>
                        <code style={{ whiteSpace: 'pre' }}>{
`from modelpark import APIManager

api = APIManager()
response = api.make_api_call(
    "my-app",
    headers={"X-ModelPark-Key": "mpk_your_api_key"}
)`
                        }</code>
                    </div>
                </div>

                <a
                    href="https://github.com/model-park/modelpark/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={Styles.ManualDownloadLink}
                    style={{ marginTop: 16 }}
                >
                    <GithubOutlined /> View on GitHub
                </a>
            </div>
        </div>
    );
}
